import { createGlobalStyle } from 'styled-components';
import img from './Psycho1.png';

const ContactStyle = createGlobalStyle`
body {
    background: url('${img}') no-repeat center center fixed;
    background-size: cover;
    font-family: Arial, sans-serif;
    background-color: #0a0a0a;
    color: #ffffff;
    font-size: 18px;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

/* Main container */
.contact-main {
    flex-grow: 1;
    padding: 40px 20px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    position: relative;
}

.contact-main::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(
        0deg,
        rgba(0, 206, 209, 0.03) 0px,
        rgba(0, 206, 209, 0.03) 1px,
        transparent 1px,
        transparent 2px
    );
    pointer-events: none;
}

.contact-container {
    max-width: 900px;
    width: 100%;
    position: relative;
}

/* Header section */
.contact-header {
    text-align: center;
    margin-bottom: 40px;
}

.contact-header h2 {
    font-size: 48px;
    font-weight: bold;
    color: #00CED1;
    text-shadow: 0 0 10px rgba(0, 206, 209, 0.8),
                 0 0 20px rgba(0, 206, 209, 0.6),
                 0 0 30px rgba(0, 206, 209, 0.4);
    margin: 0;
    letter-spacing: 2px;
}

/* Contact info card */
.contact-info-card {
    background: rgba(0, 0, 0, 0.75);
    border: 2px solid #00CED1;
    border-radius: 12px;
    padding: 30px;
    margin-bottom: 40px;
    text-align: center;
    backdrop-filter: blur(10px);
    animation: shadow-move-cyan 4s ease-in-out infinite;
    position: relative;
    overflow: hidden;
}

.contact-info-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(
        0deg,
        rgba(0, 206, 209, 0.05) 0px,
        rgba(0, 206, 209, 0.05) 1px,
        transparent 1px,
        transparent 2px
    );
    pointer-events: none;
}

.contact-text {
    font-size: 20px;
    font-weight: bold;
    color: #ffffff;
    font-family: Arial, sans-serif;
    text-align: center;
    text-shadow: 0 0 5px rgba(0, 206, 209, 0.5);
    margin: 15px 0;
}

.email-link {
    display: inline-block;
    font-size: 24px;
    font-weight: bold;
    color: #00CED1;
    text-decoration: none;
    margin: 20px 0;
    padding: 15px 30px;
    border: 2px solid #00CED1;
    border-radius: 8px;
    background: rgba(0, 206, 209, 0.1);
    transition: all 0.3s ease;
    text-shadow: 0 0 10px rgba(0, 206, 209, 0.8);
}

.email-link:hover {
    background: rgba(0, 206, 209, 0.2);
    box-shadow: 0 0 20px rgba(0, 206, 209, 0.6),
                0 0 30px rgba(0, 206, 209, 0.4);
    transform: scale(1.05);
}

/* Forms section */
.forms-section {
    display: flex;
    flex-direction: column;
    gap: 40px;
}

/* Comment form */
.cform {
    background: rgba(0, 0, 0, 0.75);
    color: #ffffff;
    border: 2px solid #00CED1;
    border-radius: 12px;
    padding: 30px;
    text-align: center;
    margin: 0 auto;
    font-family: Arial, sans-serif;
    animation: shadow-move-cyan 4s ease-in-out infinite;
    backdrop-filter: blur(10px);
    width: 100%;
    max-width: 600px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
}

.cform::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(
        0deg,
        rgba(0, 206, 209, 0.05) 0px,
        rgba(0, 206, 209, 0.05) 1px,
        transparent 1px,
        transparent 2px
    );
    pointer-events: none;
}

.cform-label {
    display: block;
    margin-bottom: 15px;
    margin-top: 15px;
    font-size: 18px;
    font-weight: bold;
    color: #00CED1;
    text-shadow: 0 0 5px rgba(0, 206, 209, 0.5);
    position: relative;
}

.cform-input,
.cform-textarea {
    box-sizing: border-box;
    background-color: rgba(17, 17, 17, 0.9);
    color: #ffffff;
    border: 2px solid #00CED1;
    border-radius: 8px;
    padding: 12px;
    margin-top: 8px;
    margin-bottom: 5px;
    width: 100%;
    font-size: 16px;
    font-family: Arial, sans-serif;
    transition: all 0.3s ease;
}

.cform-input:focus,
.cform-textarea:focus {
    outline: none;
    border-color: #00eaff;
    box-shadow: 0 0 10px rgba(0, 206, 209, 0.5);
}

.cform-textarea {
    min-height: 120px;
    resize: vertical;
}

.cform-submit {
    background: linear-gradient(135deg, #00CED1 0%, #00a8aa 100%);
    color: #ffffff;
    border: 2px solid #00CED1;
    border-radius: 8px;
    padding: 12px 30px;
    margin-top: 20px;
    margin-bottom: 5px;
    cursor: pointer;
    font-size: 18px;
    font-weight: bold;
    text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    transition: all 0.3s ease;
    position: relative;
}

.cform-submit:hover:not(:disabled) {
    background: linear-gradient(135deg, #00eaff 0%, #00CED1 100%);
    box-shadow: 0 0 20px rgba(0, 206, 209, 0.6),
                0 0 30px rgba(0, 206, 209, 0.4);
    transform: scale(1.05);
}

.cform-submit:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Comment list */
.comment {
    border: 2px solid #00CED1;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px;
    width: 100%;
    max-width: 600px;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.75);
    display: block;
    margin-left: auto;
    margin-right: auto;
    animation: shadow-move-cyan 4s ease-in-out infinite;
    backdrop-filter: blur(10px);
    position: relative;
    overflow: hidden;
}

.comment::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(
        0deg,
        rgba(0, 206, 209, 0.05) 0px,
        rgba(0, 206, 209, 0.05) 1px,
        transparent 1px,
        transparent 2px
    );
    pointer-events: none;
}

.comment p {
    font-size: 16px;
    font-weight: normal;
    color: #ffffff;
    font-family: Arial, sans-serif;
    text-align: left;
    text-shadow: 0 0 3px rgba(0, 206, 209, 0.3);
    margin: 8px 0;
    position: relative;
}

.comment p strong {
    color: #00CED1;
    text-shadow: 0 0 5px rgba(0, 206, 209, 0.5);
}

.comment hr {
    border: none;
    border-top: 1px solid rgba(0, 206, 209, 0.3);
    margin: 10px 0;
}

/* Loader */
.cloader {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    border: 10px solid;
    box-sizing: border-box;
    animation: animloader 1s linear infinite alternate;
}

@keyframes animloader {
    0% {
        border-color: #00CED1 rgba(0, 206, 209, 0) rgba(0, 206, 209, 0) rgba(0, 206, 209, 0);
    }
    33% {
        border-color: #00CED1 #00CED1 rgba(0, 206, 209, 0) rgba(0, 206, 209, 0);
    }
    66% {
        border-color: #00CED1 #00CED1 #00CED1 rgba(0, 206, 209, 0);
    }
    100% {
        border-color: #00CED1 #00CED1 #00CED1 #00CED1;
    }
}

/* Moving shadow animation */
@keyframes shadow-move-cyan {
    0% {
        box-shadow: 0 0 0 rgba(0, 206, 209, 0.4);
    }
    25% {
        box-shadow: 10px 10px 10px rgba(0, 206, 209, 0.4);
    }
    50% {
        box-shadow: 20px 10px 0 rgba(0, 206, 209, 0.4);
    }
    75% {
        box-shadow: -10px -10px 10px rgba(0, 206, 209, 0.4);
    }
    100% {
        box-shadow: -10px -10px 0 rgba(0, 206, 209, 0.4);
    }
}

/* Header and nav */
header {
    background-color: #333;
    padding: 20px;
    padding-bottom: 30px;
    margin: 0 auto;
}

nav ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

nav ul li {
    display: inline-block;
    margin-right: 20px;
}

nav ul li button {
    background-color: transparent;
    border: none;
    cursor: pointer;
}

nav ul li:last-child {
    margin-right: 0;
}

nav ul li a,
nav ul li button {
    color: #fff;
    text-decoration: none;
    font-size: 20px;
    font-weight: bold;
    text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
    transition: text-shadow 0.3s ease;
    position: relative;
}

nav ul li a:hover,
nav ul li button:hover {
    color: #00CED1;
    text-shadow: 1px 1px 2px #00CED1, 0 0 1em #00CED1, 0 0 0.2em #00CED1;
    animation: electric 1s infinite;
}

@keyframes electric {
    0% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
    50% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6), 0 0 20px #00eaff;
    }
    100% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
}

/* Footer - Handled by EnhancedFooter component */
/* footer {
    height: 60px;
    background-color: #333;
    color: #fff;
    text-align: center;
    font-size: 18px;
    padding-top: 20px;
    margin-top: auto;
} */

/* Responsive design */
@media (max-width: 768px) {
    .contact-header h2 {
        font-size: 36px;
    }

    .contact-info-card,
    .cform,
    .comment {
        padding: 20px;
    }

    .email-link {
        font-size: 20px;
        padding: 12px 24px;
    }
}
`;
export default ContactStyle;